import {Component} from 'react';
import * as firebase from 'firebase';

/** @class ReactFireComponent
  * Provides Firebase binding functions for a
  * React component.
  */
export default class ReactFireComponent extends Component {
  /** @constructor
    * Constructs a new ReactFireComponent
    */
  constructor(props) {
    super(props);
    this.firebaseRefs = {}
    this.firebaseListeners = {}
    this.firebaseKeys = {};
    this.bindAsArray = this.bindAsArray.bind(this);
    this.bindAsObject = this.bindAsObject.bind(this);
    this.unbind = this.unbind.bind(this);
  }
  /** @method bindAsArray
    * Binds the supplied firebase database ref to
    * the supplied variable.  Items added or removed
    * from the array will automatically be updated in
    * the component's state.  If the items in the array
    * have an `order` property, the array will be
    * sorted on that property.
    * @prop {url} firebaseURL - the firebase ref
    * @prop {string} bindVar - the state variable to hold the array
    */
  bindAsArray(firebaseURL, bindVar) {
    var firebaseRef = firebase.database().ref(firebaseURL);
    this.firebaseKeys[bindVar] = [];
    this.firebaseRefs[bindVar] = firebaseRef;
    // Dynamic event handlers
    var childAdded = (snapshot) => {
      var data = this.state[bindVar];
      var item = snapshot.val();
      item.id = snapshot.key;
      item.firebaseRef = firebaseRef.child(snapshot.key);
      this.firebaseKeys[bindVar].push(snapshot.key);
      data.push(item);
      data = data.sort((a,b) => {return a.order - b.order});
      const keys = data.map((a) => {return a.id});
      this.setState({[bindVar]: data},()=>{
        this.firebaseKeys[bindVar] = keys;
      });
    };
    var childRemoved = (snapshot) => {
      var data = this.state[bindVar];
      var index = this.firebaseKeys[bindVar].indexOf(snapshot.key);
      if(index === -1) throw new Error("ReactFire: Invalid child key");
      data.splice(index, 1);
      this.firebaseKeys[bindVar].splice(index, 1);
      this.setState({[bindVar]: data});
    }
    var childChanged = (snapshot) => {
      var data = this.state[bindVar];
      var index = this.firebaseKeys[bindVar].indexOf(snapshot.key);
      if(index === -1) throw new Error("ReactFire: Invalid child key");
      data[index] = snapshot.val();
      data[index].id = snapshot.key;
      data = data.sort((a,b) => {return a.order - b.order});
      const keys = data.map((a) => {return a.id});
      this.setState({[bindVar]: data},()=>{
        this.firebaseKeys[bindVar] = keys;
      });
    }
    this.firebaseListeners[bindVar] = {};
    this.firebaseListeners[bindVar]['child_added'] = childAdded;
    this.firebaseListeners[bindVar]['child_removed'] = childRemoved;
    this.firebaseListeners[bindVar]['child_changed'] = childChanged;
    firebaseRef.on('child_added', childAdded);
    firebaseRef.on('child_changed', childChanged);
    firebaseRef.on('child_removed', childRemoved);
  }
  /** @method bindAsObject
    * Binds a firebase database reference to a state variable
    * @param {url} firebaseURL - the ref to bind
    * @param {string} bindVar - the state variable to bind to.
    */
  bindAsObject(firebaseURL, bindVar) {
    var firebaseRef = firebase.database().ref(firebaseURL);
    this.firebaseRefs[bindVar] = firebaseRef;
    var value = (snapshot) => {
      this.setState({[bindVar]: snapshot.val()});
    }
    this.firebaseListeners[bindVar] = {};
    this.firebaseListeners[bindVar]['value'] = value;
    firebaseRef.on('value', value);
  }
  /** @method unbind
    * Unbinds a bound variable from the firebase database
    * @param {string} bindVar - the variable to unbind
    */
  unbind(bindVar) {
    for(var event in this.firebaseListeners[bindVar]) {
      this.firebaseRefs[bindVar].off(event, this.firebaseListeners[bindVar][event]);
    }
    this.firebaseListeners[bindVar] = undefined;
    this.firebaseRefs[bindVar] = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/components/react-fire-component/react-fire-component.js